<script>
  import { apiFetch } from "../lib/api.js";
  import { user } from "../stores/user";
  import { BASE_URL } from "../stores/BASE_URL";
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import Navbar from "../components/Navbar.svelte";
  import CardContent from "../components/CardContent.svelte";
  import { formatNumber } from "../services/formatNumber";

  let clientes = [];
  import CountrySelect from "../components/CountrySelect.svelte";
  let isAdding = false;

  let usuario = {
    id_cliente: 0,
    plan: "Bronze I",
    usuario: "",
    documento: "",
    tipo_documento: "DNI",
    clave: "",
    nombres: "",
    inicio: "0001-01-01",
    fin: "0001-01-01",
    consultas: "0",
    consultas_contrato: "0",
    estado: "1",
    rol: "2",
    consultas_masivos: "0",
    consultas_filtros: "0",
    celular_codigo: "51",
    celular: "",
    exists: [],
  };

  const planes = {
    "Bronze I": { filtros: "0", masivos: "0", d_filtros: true, d_masivos: true },
    "Bronze II": { filtros: "0", masivos: "0", d_filtros: true, d_masivos: true },
    "Silver I": { filtros: "0", masivos: "0", d_filtros: true, d_masivos: true },
    "Silver II": { filtros: "0", masivos: "0", d_filtros: true, d_masivos: true },
    "Gold I": { filtros: "0", masivos: "0", d_filtros: true, d_masivos: true },
    Platinum: { filtros: "0", masivos: "0", d_filtros: true, d_masivos: true },
    Signature: { filtros: "0", masivos: "0", d_filtros: true, d_masivos: true },
    "Ilimitado I": { filtros: "0", masivos: "0", d_filtros: true, d_masivos: true },
    "Ilimitado II": { filtros: "0", masivos: "0", d_filtros: true, d_masivos: false },
    "Ilimitado III": { filtros: "0", masivos: "0", d_filtros: false, d_masivos: false },
    "Ilimitado IV": { filtros: "0", masivos: "0", d_filtros: false, d_masivos: false },
    "Gold II": { filtros: "0", masivos: "0", d_filtros: true, d_masivos: true },
    "Grupal III": { filtros: "0", masivos: "0", d_filtros: true, d_masivos: true },
    "Grupal II": { filtros: "0", masivos: "0", d_filtros: true, d_masivos: true },
    "Grupal I": { filtros: "0", masivos: "0", d_filtros: true, d_masivos: true },
    API: { filtros: "0", masivos: "0", d_filtros: true, d_masivos: true },
  };

  const PLANES_LIMITES = {
    "Bronze I": { minimo: 25, maximo: 500_000, minimo_masivo: 0, maximo_masivo: 0 },
    "Bronze II": { minimo: 25, maximo: 500_000, minimo_masivo: 0, maximo_masivo: 0 },
    "Silver I": { minimo: 100, maximo: 500_000, minimo_masivo: 100, maximo_masivo: 500_000 },
    "Silver II": { minimo: 100, maximo: 500_000, minimo_masivo: 100, maximo_masivo: 500_000 },
    "Gold I": { minimo: 500, maximo: 500_000, minimo_masivo: 500, maximo_masivo: 500_000 },
    Platinum: { minimo: 15_000, maximo: 500_000, minimo_masivo: 15_000, maximo_masivo: 500_000 },
    Signature: { minimo: 15_000, maximo: 500_000, minimo_masivo: 15_000, maximo_masivo: 500_000 },
    "Ilimitado I": { minimo: 10_000, maximo: 3_000_000, minimo_masivo: 0, maximo_masivo: 0 },
    "Ilimitado II": { minimo: 10_000, maximo: 3_000_000, minimo_masivo: 10_000, maximo_masivo: 3_000_000 },
    "Ilimitado III": { minimo: 10_000, maximo: 3_000_000, minimo_masivo: 10_000, maximo_masivo: 3_000_000 },
    "Ilimitado IV": { minimo: 10_000, maximo: 3_000_000, minimo_masivo: 10_000, maximo_masivo: 3_000_000 },
    "Gold II": { minimo: 500, maximo: 100_000, minimo_masivo: 500, maximo_masivo: 500_000 },
    "Grupal III": { minimo: 25, maximo: 500_000, minimo_masivo: 25, maximo_masivo: 500_000 },
    "Grupal II": { minimo: 25, maximo: 500_000, minimo_masivo: 25, maximo_masivo: 500_000 },
    "Grupal I": { minimo: 25, maximo: 500_000, minimo_masivo: 25, maximo_masivo: 500_000 },
    API: { minimo: 50_000, maximo: 2_000_000, minimo_masivo: 0, maximo_masivo: 0 },
  };

  const getClientes = async () => {
    const response = await apiFetch(`${BASE_URL}cliente.php?action=getClientes`);
    const resp = await response.json();
    clientes = resp.data;
    usuario.id_cliente = clientes[0].id;
  };

  const handleSubmit = () => {
    if (usuario.usuario == "" || usuario.documento == "" || usuario.nombres == "") {
      alert("Datos icompletos");
      return;
    }

    if (!validarCaracteres(usuario.clave)) {
      alert(
        "La clave debe tener al menos 10 caracteres, incluyendo una letra mayúscula, una letra minúscula, un número y al menos dos caracteres especiales (!*/#%@$_&-)",
      );
      return;
    }

    // if (!validarLimites()) {
    //   return;
    // }

    addUsuario();
  };

  const handlePlan = () => {
    // Masivos
    if (
      usuario.plan == "Silver I" ||
      usuario.plan == "Silver II" ||
      usuario.plan == "Gold I" ||
      usuario.plan == "Platinum" ||
      usuario.plan == "Signature" ||
      usuario.plan == "Gold II" ||
      usuario.plan == "Grupal III" ||
      usuario.plan == "Grupal II" ||
      usuario.plan == "Grupal I"
    ) {
      usuario.consultas_masivos = usuario.consultas_contrato;
    } else {
      usuario.consultas_masivos = "0";
    }

    // Filtros
    if (usuario.plan == "Gold II" || usuario.plan == "Grupal III" || usuario.plan == "Signature") {
      usuario.consultas_filtros = usuario.consultas_contrato;
    } else {
      usuario.consultas_filtros = "0";
    }
  };

  const handleConsultasContratoInput = (event) => {
    const formattedValue = formatNumber(event.target.value);
    usuario.consultas_contrato = formattedValue;

    // Masivos
    if (
      usuario.plan == "Silver I" ||
      usuario.plan == "Silver II" ||
      usuario.plan == "Gold I" ||
      usuario.plan == "Platinum" ||
      usuario.plan == "Signature" ||
      usuario.plan == "Gold II" ||
      usuario.plan == "Grupal III" ||
      usuario.plan == "Grupal II" ||
      usuario.plan == "Grupal I"
    ) {
      usuario.consultas_masivos = usuario.consultas_contrato;
    } else {
      usuario.consultas_masivos = "0";
    }

    // Filtros
    if (usuario.plan == "Gold II" || usuario.plan == "Grupal III" || usuario.plan == "Signature") {
      usuario.consultas_filtros = usuario.consultas_contrato;
    } else {
      usuario.consultas_filtros = "0";
    }
  };

  const handleConsultasInput = (event) => {
    const formattedValue = formatNumber(event.target.value);
    usuario.consultas = formattedValue;
  };

  const handleConsultasMasivosInput = (event) => {
    const formattedValue = formatNumber(event.target.value);
    usuario.consultas_masivos = formattedValue;
  };

  const handleConsultasFiltrosInput = (event) => {
    const formattedValue = formatNumber(event.target.value);
    usuario.consultas_filtros = formattedValue;
  };

  const addUsuario = async () => {
    if (!esCelularValido(usuario.celular, usuario.celular_codigo)) {
      alert("Por favor, ingresa un número de celular válido");
      return;
    }

    let celular_existe = await elCelularexiste(usuario.celular);
    if (celular_existe.data.length > 0) {
      alert("El celular (" + usuario.celular + ") está registrado en:\n\n" + celular_existe.message);
      return;
    }

    isAdding = true;
    const formData = new FormData();
    formData.append("id_cliente", usuario.id_cliente);
    formData.append("usuario", usuario.usuario);
    formData.append("clave", usuario.clave);
    formData.append("tipo_documento", usuario.tipo_documento);
    formData.append("documento", usuario.documento);
    formData.append("nombres", usuario.nombres);
    formData.append("inicio", usuario.inicio);
    formData.append("fin", usuario.fin);
    formData.append("plan", usuario.plan);
    formData.append("consultas", usuario.consultas.replace(/[^\d.]/g, ""));
    formData.append("consultas_contrato", usuario.consultas_contrato.replace(/[^\d.]/g, ""));
    formData.append("consultas_masivos", usuario.consultas_masivos.replace(/[^\d.]/g, ""));
    formData.append("consultas_filtros", usuario.consultas_filtros.replace(/[^\d.]/g, ""));
    formData.append("estado", usuario.estado);
    formData.append("rol", usuario.rol);
    formData.append("action", "addUsuario");
    formData.append("session_id_usuario", $user.idUsuario);
    formData.append("celular", usuario.celular);
    formData.append("celular_codigo", usuario.celular_codigo);

    const response = await apiFetch(`${BASE_URL}usuario.php`, {
      method: "POST",
      body: formData,
    });

    const resp = await response.json();
    if (resp.status == "success") {
      navigate(`/usuarios`, { replace: true });
    } else {
      alert(resp.message);
    }

    isAdding = false;
  };

  const changeDocumento = async () => {
    if (usuario.tipo_documento == "DNI" && usuario.documento.length == 8) {
      getNombresByDocumento();
    } else if (usuario.tipo_documento == "CARNET EXT." && usuario.documento.length > 8) {
      getNombresByDocumento();
    } else {
      usuario.exists = [];
      usuario.nombres = "";
    }
  };

  const getNombresByDocumento = async () => {
    const response = await apiFetch(`${BASE_URL}usuario.php?action=getNombresByDocumento&documento=${usuario.documento}`);
    const resp = await response.json();
    if (resp.status == "success") {
      usuario.exists = resp.data.exists;
      usuario.nombres = capitalizarNombres(resp.data.nombres);
      if (usuario.exists.length > 0) {
        let usuarios_text = usuario.exists.map((empresa) => "•  " + empresa.razon_social).join("\n");
        alert("El usuario (" + usuario.nombres + ") está registrado en:\n\n" + usuarios_text);
      }
    } else {
      usuario.exists = [];
      usuario.nombres = "";
    }
  };

  const capitalizarNombres = (nombres) => {
    return nombres.toLowerCase().replace(/(^\w|\s\w)/g, function (letra) {
      return letra.toUpperCase();
    });
  };

  const validarCaracteres = (clave) => {
    let re = /^(?=.*\d)(?=(.*[!*/#%@$_&-]){2,})(?=.*[a-z])(?=.*[A-Z]).{10,}$/;
    return re.test(clave);
  };

  const validarLimites = () => {
    let validate = true;

    if (
      Number(usuario.consultas_contrato.replace(/[^\d.]/g, "")) < PLANES_LIMITES[usuario.plan].minimo ||
      Number(usuario.consultas_contrato.replace(/[^\d.]/g, "")) > PLANES_LIMITES[usuario.plan].maximo
    ) {
      alert(
        `Para el plan ${usuario.plan} el valor de consultas contratadas debe estar entre ${formatNumber(PLANES_LIMITES[usuario.plan].minimo)} y ${formatNumber(PLANES_LIMITES[usuario.plan].maximo)}`,
      );
      validate = false;
    }

    if (
      Number(usuario.consultas_masivos.replace(/[^\d.]/g, "")) < PLANES_LIMITES[usuario.plan].minimo_masivo ||
      Number(usuario.consultas_masivos.replace(/[^\d.]/g, "")) > PLANES_LIMITES[usuario.plan].maximo_masivo
    ) {
      alert(
        `Para el plan ${usuario.plan} el valor de consultas masivas debe estar entre ${formatNumber(PLANES_LIMITES[usuario.plan].minimo_masivo)} y ${formatNumber(PLANES_LIMITES[usuario.plan].maximo_masivo)}`,
      );
      validate = false;
    }

    return validate;
  };

  const esCelularValido = (str, pais) => {
    if (pais == "51") {
      // Perú: empieza con 9 y tiene 9 dígitos
      return /^9\d{8}$/.test(str);
    } else if (pais == "52") {
      // México: empieza con 55, 56 o 33, o cualquier otro código válido, y tiene 10 dígitos
      return /^\d{10}$/.test(str);
    } else if (pais == "1") {
      // Estados Unidos: 10 digitos
      return /^1?\d{10}$/.test(str);
    }
    return false;
  };

  const elCelularexiste = async (celular) => {
    let celular_existe = {
      message: "",
      data: [],
    };

    const response = await apiFetch(`${BASE_URL}usuario.php?action=elCelularexiste&celular=${celular}`);
    const resp = await response.json();
    if (resp.status) {
      celular_existe.data = resp.data;
      if (celular_existe.data.length > 0) {
        celular_existe.message = celular_existe.data.map((u) => "•  " + u.usuario).join("\n");
      }
    }

    return celular_existe;
  };

  getClientes();

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true });
    }
  });
</script>

{#if $user}
  <Navbar />
  <div class="container-fluid py-3">
    <CardContent title="Agregar usuario">
      <form on:submit|preventDefault={handleSubmit} autocomplete="off">
        <div class="row mt-3">
          <div class="col-12 col-sm-12 col-md-6 col-lg-2 mb-3">
            <label class="w-100">
              <span class="form-label"> Tipo Documento </span>
              <select class="form-select" bind:value={usuario.tipo_documento} on:change={changeDocumento}>
                <option value="DNI">DNI</option>
                <option value="CARNET EXT.">CARNET EXT.</option>
              </select>
            </label>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-2 mb-3">
            <label class="w-100">
              <span class="form-label"> Documento </span>
              <input type="text" class="form-control" bind:value={usuario.documento} on:input={changeDocumento} autocomplete="off" />
            </label>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-3 mb-3">
            <label class="w-100">
              <span class="form-label"> Nombres </span>
              <input type="text" class="form-control" bind:value={usuario.nombres} disabled />
              <!-- {#if usuario.nombres.trim() != "" && usuario.exists.length > 0}
                <div class="small text-danger">
                  El usuario está registrado en ({usuario.exists
                    .map((empresa) => empresa.razon_social)
                    .join(",")})
                </div>
              {/if} -->
            </label>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-3 mb-3">
            <label class="w-100">
              <span class="form-label">Cliente</span>
              <select class="form-select" bind:value={usuario.id_cliente}>
                {#each clientes as cliente}
                  <option value={cliente.id}>{cliente.razon_social}</option>
                {/each}
              </select>
            </label>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-2 mb-3">
            <label class="w-100">
              <span class="form-label"> Plan </span>
              <select class="form-select form-select-primary" bind:value={usuario.plan} on:change={handlePlan}>
                <option value="Bronze I">Bronze I</option>
                <option value="Bronze II">Bronze II</option>
                <option value="Silver I">Silver I</option>
                <option value="Silver II">Silver II</option>
                <option value="Gold I">Gold I</option>
                <option value="Gold II">Gold II</option>
                <option value="Platinum">Platinum</option>
                <option value="Signature">Signature</option>
                <option value="Ilimitado I">Ilimitado I</option>
                <option value="Ilimitado II">Ilimitado II</option>
                <option value="Ilimitado III">Ilimitado III</option>
                <option value="Ilimitado IV">Ilimitado IV</option>
                <option value="Grupal III">Grupal III</option>
                <option value="Grupal II">Grupal II</option>
                <option value="Grupal I">Grupal I</option>
                <option value="API">API</option>
              </select>
            </label>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-2 mb-3">
            <label class="w-100">
              <span class="form-label">Usuario</span>
              <input class="form-control" type="text" bind:value={usuario.usuario} name="new_username" autocomplete="new-username" />
            </label>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-2 mb-3">
            <label class="w-100">
              <span class="form-label">Clave</span>
              <input class="form-control" type="password" bind:value={usuario.clave} name="new_password" autocomplete="new-password" />
            </label>
          </div>

          <div class="col-12 col-sm-12 col-md-6 col-lg-2 mb-3">
            <label class="w-100">
              <span class="form-label">Inicio</span>
              <input class="form-control" type="date" bind:value={usuario.inicio} />
            </label>
          </div>

          <div class="col-12 col-sm-12 col-md-6 col-lg-2 mb-3">
            <label class="w-100">
              <span class="form-label">Fin</span>
              <input class="form-control" type="date" bind:value={usuario.fin} />
            </label>
          </div>

          <div class="col-12 col-sm-12 col-md-6 col-lg-2 mb-3">
            <label class="w-100">
              <span class="form-label">Consultas contratadas</span>
              <input class="form-control" type="text" bind:value={usuario.consultas_contrato} on:input={handleConsultasContratoInput} />
            </label>
          </div>

          <div class="col-12 col-sm-12 col-md-6 col-lg-2 mb-3">
            <label class="w-100">
              <span class="form-label">Consultas</span>
              <input class="form-control" type="text" bind:value={usuario.consultas} on:input={handleConsultasInput} />
            </label>
          </div>

          <div class="col-12 col-sm-12 col-md-6 col-lg-2 mb-3">
            <label class="w-100">
              <span class="form-label">Rol</span>
              <select class="form-select" id="rol" bind:value={usuario.rol}>
                <option value="2">Usuario</option>
                <option value="1">Administrador</option>
              </select>
            </label>
          </div>

          <div class="col-12 col-sm-12 col-md-6 col-lg-2 mb-3">
            <label class="w-100">
              <span class="form-label">Estado</span>
              <select class="form-select" id="estado" bind:value={usuario.estado}>
                <option value="1">Activo</option>
                <option value="2">Suspendido</option>
                <option value="0">De baja</option>
              </select>
            </label>
          </div>

          <div class="col-12 col-sm-12 col-md-6 col-lg-2 mb-3">
            <label class="w-100">
              <span class="form-label">Cant. Masivos</span>
              <input
                class="form-control"
                type="text"
                bind:value={usuario.consultas_masivos}
                on:input={handleConsultasMasivosInput}
                disabled={planes[usuario.plan].d_masivos}
              />
            </label>
          </div>

          <div class="col-12 col-sm-12 col-md-6 col-lg-2 mb-3">
            <label class="w-100">
              <span class="form-label">Cant. Filtros</span>
              <input
                class="form-control"
                type="text"
                bind:value={usuario.consultas_filtros}
                on:input={handleConsultasFiltrosInput}
                disabled={planes[usuario.plan].d_filtros}
              />
            </label>
          </div>

          <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xxl-2 mb-3">
            <label class="w-100">
              <span class="form-label">Celular</span>
              <div class="d-flex gap-1">
                <CountrySelect bind:selected={usuario.celular_codigo} />
                <input class="form-control" type="text" bind:value={usuario.celular} />
              </div>
            </label>
          </div>

          <div class="col-12 mb-3 text-end">
            {#if isAdding}
              <button class="btn btn-primary" disabled> Agregando... </button>
            {:else}
              <button class="btn btn-primary">Agregar</button>
            {/if}
          </div>
        </div>
      </form>
    </CardContent>
  </div>
{/if}

<style>
  .form-select.form-select-primary {
    background-color: #cfe2ff; /* Color primario más claro */
    color: #084298; /* Color del texto */
  }
</style>
